<style lang="less" scoped>
  .product-info{
    background-color: #f5f5f5;
    padding-bottom: 10px;
  }
</style>
<template>
  <div class="product-info">
    <product-coupon v-if="isCoupon" :activeCode="activeCode" :activeDetail="activeDetail"></product-coupon>
    <product-normal v-else :activeCode="activeCode" :activeDetail="activeDetail"></product-normal>
  </div>
</template>
<script>
import productCoupon from './product_coupon'
import productNormal from './product_normal'
import { mapActions } from 'vuex'

export default {
  props: ['activeCode'],
  data() {
    return {
      activeDetail:{},
    }
  },
  components: {
    productCoupon,
    productNormal,
  },
  computed:{
    isCoupon() {
      return this.activeDetail.batchItemType === 1
    },
  },
  methods: {
    ...mapActions([
      'getActiveDetail',
    ]),
  },
  mounted() {
    
    this.getActiveDetail({
      activeCode: this.activeCode,
    }).then(data => {
      this.activeDetail = data;
      this.$store.commit('setPreorderSkuList', data.productInfo.skuList)
    })
  }

}
</script>
